module.exports = __webpack_public_path__ + "media/images/plans/photo_location/img-location-dress-77318887a3866130959291dce5f8af94.png";